// extracted by mini-css-extract-plugin
export var Copyright = "styles-module--Copyright--1xH2W";
export var BackGround = "styles-module--BackGround--3qN0z";